import FacilityTypeEntity from '../entities/FacilityType.Entity';
import { apiGet } from '../support/helpers/ApiConnection.Helper';

export default function getFacilityTypes(abortSignal: AbortSignal): Promise<Array<FacilityTypeEntity>> {
    return apiGet<Array<FacilityTypeEntity>>('/facility-types', abortSignal);
}
